import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { TRANSFORMS } from '../units';

export const CensusComparisonTable = ({ censusTable, prepend }) => {
  const headerRow = censusTable[0];
  const rows = [...censusTable].splice(1);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="census comparison table" size="small">
        <TableHead>
          <TableRow>
            {
              headerRow.row.map((col) => (
                <TableCell key={col || 'blank'}>
                  <strong>{prepend && col && !['USA'].includes(col) ? `${prepend} ${col}` : col}</strong>
                </TableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map((row) => (
              <TableRow key={row.label}>
                {row.row.map((col, i) => (
                  <TableCell
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${row.label}-${col}-${i}`}
                  >
                      {typeof col === 'string' ? (<strong>{col}</strong>) : TRANSFORMS[row.unit](col)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}
